export enum WhereUsedCaller {
  LearningObject,
  Question,
}
